import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import React, { useCallback, useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { IdlePeriodSettingsFormModel, IdlePeriodSettingsModel } from 'src/Libs/smart-charge/models'
import { fromIdlePeriodModelToForm } from 'src/Libs/smart-charge/transformers'
import { makeStyles } from 'tss-react/mui'
import EmsIdlePeriodForm from 'src/Libs/smart-charge/components/ems-idle-period/EmsIdlePeriodForm'
import FormikWithExitHandler from 'src/Libs/form/components/FormikWithExitHandler'
import { useAppRatingContext } from 'src/Libs/app-rating/hooks'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.space(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
}))

interface Props {
  model: IdlePeriodSettingsModel
  onChange: (values: IdlePeriodSettingsFormModel) => Promise<void>
  hasWritingRights?: boolean
}

const EmsIdlePeriodsSection: React.FC<Props> = ({ model, onChange, hasWritingRights = true }) => {
  const { t } = useCustomTranslation()
  const [expanded, setExpanded] = useState<boolean>(false)
  const [formValues, setFormValues] = useState(fromIdlePeriodModelToForm(model))
  const { classes } = useStyles()
  const { triggerAppRating } = useAppRatingContext()

  const callback = useCallback(() => {
    setExpanded(!expanded)
  }, [expanded])

  const handleSubmit = async (values: IdlePeriodSettingsFormModel): Promise<void> => {
    try {
      await onChange(values)
      triggerAppRating()
    } catch (error) {
      /* revert changes */
      if (formValues) setFormValues({ ...formValues })
    }
  }

  return (
    <FormikWithExitHandler formKey="ems-idle-period-form" enableReinitialize={true} initialValues={formValues} onSubmit={handleSubmit}>
      <AccordionItem
        expanded={true}
        callback={callback}
        title={t('systemSettings.smartFunctions.smartCharge.emsIdlePeriods.sectionTitle')}
        contentClassName={classes.contentAccordion}
        headerContentClassName={classes.headerContent}
      >
        <EmsIdlePeriodForm model={formValues} hasWritingRights={hasWritingRights} />
      </AccordionItem>
    </FormikWithExitHandler>
  )
}

export default EmsIdlePeriodsSection
